// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { Status as UIStatus } from '@plesk/ui-library';

export const Status = styled(UIStatus)`
  margin-left: 3px;
`;
